import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ConfigService } from '@fpr/core/services/config.service';
import { LocaleService } from '@fpr/core/services/locale.service';
import { WINDOW } from '@fpr/core/services/window.factory';

@Injectable({
    providedIn: 'root'
})
export class RedirectGuard  {
    private readonly configService = inject(ConfigService);
    private readonly localeService = inject(LocaleService);
    private readonly window = inject<Window>(WINDOW);


    canActivate(route: ActivatedRouteSnapshot): boolean {

        const uri = this.configService[route.data.externalUriConfig] || route.data.externalUri;

        if (uri) {
            this.window.location.href = this.localeService.getPathWithLocale(uri);

            return true;
        } else {
            return false;
        }

    }

}
